module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description_with_reward":"Write about the following keywords to receive extra rewards after AI analysis.","description_wihout_reward":"Try writing about the following keywords."}}')
  delete Component.options._Ctor
}
